module.exports = __webpack_public_path__ + "static/img/tzbj.8d0df4ae.png";